module.exports = __webpack_public_path__ + "img/gopay.f2c1820d.png";